var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ParentPortal',{attrs:{"tabs":_vm.sidePanelComponents}},[(_vm.award)?_c('router-view',{staticClass:"main-content",attrs:{"award":_vm.award}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }